import { put, take, fork } from 'redux-saga/effects'
import { handleRequest } from './requests'
import {
    ConstantsActions,
    saveConstants,
    saveProfileOptions,
    setLocationOptions,
    getConstantTags,
    updateCategoryTags,
    saveOnboardingOptions,
} from '../state/constants'
import { STATE_KEYS } from '../state/requests'
import {
    LocationOptionsResponse,
    ConstantsRequest,
    ConstantsResponse,
    LocationOptionsRequest,
    getConstants,
    getLocationOptions,
    getProfileOptions,
    ProfileOptionsRequest,
    ProfileOptionsResponse,
    AddTagPayload,
    addTag,
    Tag,
    getTags,
    GetTagsPayload,
    getOnboardingOptions,
    OnboardingOptionsResponse,
} from '../services/api/constants'

export function* handleGetConstants(): any {
    yield handleRequest<ConstantsRequest, ConstantsResponse>({
        stateKey: STATE_KEYS.Constants,
        payload: {},
        ApiHandler: getConstants,
        *onSuccess(response) {
            const responseData = {
                ...(response.data !== undefined ? response.data.data : undefined),
            }
            yield put(
                saveConstants({
                    data: responseData as any,
                }),
            )
        },
    })
}

export function* watchConstantsRequestFlow(): any {
    while (true) {
        yield take(ConstantsActions.CONSTANTS_REQUEST)
        yield fork(handleGetConstants)
    }
}

export function* handleGetLocationOptions(payload: LocationOptionsRequest): any {
    yield handleRequest<LocationOptionsRequest, LocationOptionsResponse>({
        stateKey: STATE_KEYS.GetLocationOptions,
        payload: { ...payload, limit: 100 },
        ApiHandler: getLocationOptions,
        *onSuccess(response) {
            yield put(
                setLocationOptions({
                    country: payload.country,
                    idName: payload.type_id_name,
                    parent: payload.parent,
                    options: response.data !== undefined ? response.data.data.results : undefined,
                }),
            )
        },
    })
}

export function* watchLocationOptionsRequestFlow(): any {
    while (true) {
        const action = yield take(ConstantsActions.GET_LOCATION_OPTIONS_REQUEST)
        yield fork(handleGetLocationOptions, action.payload)
    }
}

export function* handleGetProfileOptions(payload: ProfileOptionsRequest): any {
    yield handleRequest<ProfileOptionsRequest, ProfileOptionsResponse>({
        stateKey: STATE_KEYS.GetProfileOptions,
        payload,
        ApiHandler: getProfileOptions,
        *onSuccess(response) {
            yield put(saveProfileOptions({ data: response.data !== undefined ? response.data.data : undefined }))
        },
    })
}

export function* watchProfileOptionsRequestFlow(): any {
    while (true) {
        const action = yield take(ConstantsActions.GET_PROFILE_OPTIONS_REQUEST)
        yield fork(handleGetProfileOptions, action.payload)
    }
}

export function* handleGetTags(payload: GetTagsPayload): any {
    yield handleRequest<GetTagsPayload, Tag[]>({
        stateKey: STATE_KEYS.AddCustomTag,
        payload,
        ApiHandler: getTags,
        *onSuccess(res) {
            if (payload.onSuccessCallback && res?.data?.data) {
                const { data } = res?.data
                yield payload.onSuccessCallback(data)
            }
        },
    })
}

export function* watchGetTags(): any {
    while (true) {
        const action = yield take(ConstantsActions.GET_TAGS)
        yield fork(handleGetTags, action.payload)
    }
}

export function* handleAddCustomTag(payload: AddTagPayload): any {
    yield handleRequest<AddTagPayload, Tag>({
        stateKey: STATE_KEYS.AddCustomTag,
        payload,
        ApiHandler: addTag,
        *onSuccess(res) {
            if (payload.onSuccessCallback && res?.data?.data) {
                const { data } = res?.data
                yield payload.onSuccessCallback(data)
            }
        },
    })
    yield put(
        getConstantTags({
            categoryId: payload.categoryUuid,
            *onSuccessCallback(value) {
                if (value) {
                    yield put(
                        updateCategoryTags({
                            tags: value,
                            categoryEnum: payload.categoryEnum,
                        }),
                    )
                }
            },
        }),
    )
}

export function* watchAddCustomTag(): any {
    while (true) {
        const action = yield take(ConstantsActions.ADD_CUSTOM_TAG)
        yield fork(handleAddCustomTag, action.payload)
    }
}

export function* handleGetOnboardingOptions(): any {
    yield handleRequest<undefined, OnboardingOptionsResponse>({
        stateKey: STATE_KEYS.GetOnboardingOptions,
        payload: undefined,
        ApiHandler: getOnboardingOptions,
        *onSuccess(response) {
            if (response.data !== undefined) {
                yield put(
                    saveOnboardingOptions({
                        ...response.data.data,
                    }),
                )
            }
        },
    })
}

export function* watchGetOnboardingOptions(): any {
    while (true) {
        yield take(ConstantsActions.GET_ONBOARDING_OPTIONS)
        yield fork(handleGetOnboardingOptions)
    }
}
